import { render, staticRenderFns } from "./CustomerFeatureCard.vue?vue&type=template&id=1490c348"
import script from "./CustomerFeatureCard.vue?vue&type=script&lang=js"
export * from "./CustomerFeatureCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports